import React from 'react';
import { useIntl, defineMessage } from 'react-intl';
import { TypedMemo } from '../../../common/types';
import { Panel, PanelBody, PanelHead } from '../primitives/Panel';
/* eslint-disable css-modules/no-unused-class */
import styles from './TrendsSummaryPanel.module.scss';
/* eslint-enable css-modules/no-unused-class */

const messages = {
  kicker: defineMessage({ id: 'app.sml.aiInsights.kicker', defaultMessage: 'AI daily brief' }),
  message: defineMessage({
    id: 'app.sml.aiInsights.dataNotReady',
    defaultMessage: 'Today’s brief will appear once trend data is processed.',
  }),
};

const SummaryDataNotReadyViewComponent: React.FC = () => {
  const intl = useIntl();
  return (
    <Panel className={styles.panel}>
      <PanelHead title={intl.formatMessage(messages.kicker)} />
      <PanelBody>
        <p className={styles.muted}>{intl.formatMessage(messages.message)}</p>
      </PanelBody>
    </Panel>
  );
};

export const SummaryDataNotReadyView = TypedMemo(SummaryDataNotReadyViewComponent);
